
(function clickOnceDirectiveDefinition() {

    'use strict';

    angular.module('ClickOnce')
        .directive('clickOnce', [
            '$parse', function($parse) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function link(scope, element, attrs) {

                        var method = $parse(attrs.clickOnce);
                        scope.buttonDisabled = false;
                        
                        var clickFn = function clickFnDef(event) {

                            event.stopPropagation();
                            event.preventDefault();


                            scope.$apply(function clickOnceApply() {

                                if (scope.buttonDisabled)
                                    return false;

                                var result = method(scope);

                                if (angular.isObject(result) && result.then) {
                                    element.addClass('disabled');
                                    scope.buttonDisabled = true;
                                    // si es una promesa actualizo el resultado cuando 
                                    // la misma se completa
                                    result.then(function () {
                                        element.removeClass('disabled');
                                        scope.buttonDisabled = false;
                                    }, function () {
                                        element.removeClass('disabled');
                                        scope.buttonDisabled = false;
                                    });
                                } else {
                                    if (result !== false)
                                        console.log('La expresión no retornó una promesa ni false. No se prevendrá un segundo click.');
                                }
                            });

                            return false;
                        };

                        element.on('click', clickFn);

                        scope.$on('$destroy', function() {
                            element.off('click', clickFn);
                        });
                    }
                };
            }
        ]);

})();